import type { QuizQuestion } from '../types/quiz'

export const quizQuestions: QuizQuestion[] = [
  {
    id: 1,
    prompt: '¿Qué te hizo detenerte en esta página hoy?',
    kind: 'choice',
    options: [
      {
        label: 'A',
        text: 'Siento que estoy estancada y no sé cómo avanzar.',
        code: 'alineacion',
      },
      {
        label: 'B',
        text: 'Sé lo que quiero, pero me cuesta pasar a la acción.',
        code: 'alineacion',
      },
      { label: 'C', text: 'Me siento desconectada de mí misma.', code: 'presencia' },
      {
        label: 'D',
        text: 'Quiero recuperar mi seguridad y confianza.',
        code: 'confianza',
      },
      {
        label: 'E',
        text: 'Estoy atravesando un cambio y necesito claridad.',
        code: 'alineacion',
      },
      {
        label: 'F',
        text: 'Siento que tengo potencial, pero algo dentro de mí me frena.',
        code: 'confianza',
      },
    ],
  },
  {
    id: 2,
    prompt: '¿Cuál de estas frases describe mejor cómo te sientes actualmente?',
    kind: 'choice',
    options: [
      {
        label: 'A',
        text: 'Estoy cansada de esforzarme y sentir que no avanzo.',
        code: 'presencia',
      },
      { label: 'B', text: 'Me cuesta confiar en mis decisiones.', code: 'confianza' },
      { label: 'C', text: 'Siento que he perdido conexión conmigo.', code: 'presencia' },
      {
        label: 'D',
        text: 'Pienso demasiado las cosas y termino paralizándome.',
        code: 'confianza',
      },
      {
        label: 'E',
        text: 'Sé que quiero algo diferente, pero no sé por dónde comenzar.',
        code: 'alineacion',
      },
      { label: 'F', text: 'Siento que estoy lista para una nueva etapa.', code: 'alineacion' },
    ],
  },
  {
    id: 3,
    prompt: '¿En qué área sientes mayor bloqueo actualmente?',
    kind: 'choice',
    options: [
      { label: 'A', text: 'Amor y relaciones.', code: 'confianza' },
      { label: 'B', text: 'Dinero y abundancia.', code: 'alineacion' },
      { label: 'C', text: 'Negocio o propósito profesional.', code: 'alineacion' },
      { label: 'D', text: 'Autoestima y seguridad.', code: 'confianza' },
      { label: 'E', text: 'Paz interior y bienestar.', code: 'presencia' },
      { label: 'F', text: 'Propósito y dirección.', code: 'alineacion' },
    ],
  },
  {
    id: 4,
    prompt: 'Cuando tienes una meta, ¿qué suele suceder?',
    kind: 'choice',
    options: [
      {
        label: 'A',
        text: 'Empiezo motivada y después pierdo constancia.',
        code: 'alineacion',
      },
      { label: 'B', text: 'Pienso demasiado y termino sin actuar.', code: 'confianza' },
      { label: 'C', text: 'Me comparo con otras personas.', code: 'confianza' },
      { label: 'D', text: 'Me da miedo equivocarme o fracasar.', code: 'confianza' },
      {
        label: 'E',
        text: 'Me saboteo cuando estoy cerca de conseguir algo.',
        code: 'confianza',
      },
      {
        label: 'F',
        text: 'Avanzo, pero siento que necesito más claridad y dirección.',
        code: 'alineacion',
      },
    ],
  },
  {
    id: 5,
    prompt: '¿Qué sientes que necesitas recuperar de ti?',
    kind: 'choice',
    options: [
      { label: 'A', text: 'Mi energía.', code: 'presencia' },
      { label: 'B', text: 'Mi confianza.', code: 'confianza' },
      { label: 'C', text: 'Mi seguridad.', code: 'confianza' },
      { label: 'D', text: 'Mi claridad.', code: 'alineacion' },
      { label: 'E', text: 'Mi motivación.', code: 'alineacion' },
      { label: 'F', text: 'Mi conexión conmigo.', code: 'presencia' },
      { label: 'G', text: 'Mi propósito.', code: 'alineacion' },
    ],
  },
  {
    id: 6,
    prompt: '¿Qué has intentado hasta ahora para cambiar esta situación?',
    kind: 'choice',
    options: [
      { label: 'A', text: 'Cursos o formaciones.', code: 'alineacion' },
      { label: 'B', text: 'Libros y desarrollo personal.', code: 'alineacion' },
      {
        label: 'C',
        text: 'Meditación, afirmaciones o visualización.',
        code: 'presencia',
      },
      { label: 'D', text: 'Terapia o coaching.', code: 'confianza' },
      { label: 'E', text: 'He intentado hacerlo por mi cuenta.', code: 'presencia' },
      {
        label: 'F',
        text: 'Muchas cosas, pero siento que sigo repitiendo algunos patrones.',
        code: 'confianza',
      },
    ],
  },
  {
    id: 7,
    prompt:
      'Si pudieras transformar UNA sola cosa durante los próximos 90 días, ¿qué sería?',
    kind: 'choice',
    options: [
      { label: 'A', text: 'Sentirme más segura.', code: 'confianza' },
      { label: 'B', text: 'Tener claridad sobre mi propósito.', code: 'alineacion' },
      { label: 'C', text: 'Mejorar mis relaciones.', code: 'confianza' },
      { label: 'D', text: 'Avanzar profesionalmente.', code: 'alineacion' },
      { label: 'E', text: 'Mejorar mi relación con el dinero.', code: 'alineacion' },
      { label: 'F', text: 'Recuperar mi energía y bienestar.', code: 'presencia' },
      { label: 'G', text: 'Dejar de autosabotearme.', code: 'confianza' },
    ],
  },
  {
    id: 8,
    prompt:
      '¿Qué tan preparada te sientes para hacer cambios reales en este momento?',
    kind: 'scale',
    options: [
      { label: '1', text: 'Todavía no estoy segura.', code: 'presencia' },
      { label: '2', text: 'Sé que necesito cambiar algo.', code: 'presencia' },
      { label: '3', text: 'Estoy buscando claridad.', code: 'alineacion' },
      { label: '4', text: 'Estoy lista para comenzar.', code: 'alineacion' },
      { label: '5', text: 'Sé que este es mi momento.', code: 'alineacion' },
    ],
  },
  {
    id: 9,
    prompt: '¿Qué te gustaría obtener de una conversación conmigo?',
    kind: 'choice',
    options: [
      { label: 'A', text: 'Entender qué podría estar bloqueándome.', code: 'presencia' },
      { label: 'B', text: 'Tener claridad sobre mi siguiente paso.', code: 'alineacion' },
      {
        label: 'C',
        text: 'Identificar patrones que estoy repitiendo.',
        code: 'confianza',
      },
      { label: 'D', text: 'Recuperar confianza y seguridad.', code: 'confianza' },
      { label: 'E', text: 'Crear un plan para comenzar a avanzar.', code: 'alineacion' },
      { label: 'F', text: 'Todas las anteriores.', code: 'all' },
    ],
  },
  {
    id: 10,
    prompt:
      'Cuéntame brevemente qué estás viviendo actualmente y qué te gustaría cambiar.',
    helper:
      'Escríbelo con tus propias palabras. No necesitas tenerlo todo claro.',
    kind: 'open',
  },
]
